export const SET_ENTRETIENS_LOADING = "SET_ENTRETIENS_LOADING";
export const SET_ENTRETIENS_ERROR = "SET_ENTRETIENS_ERROR";

export const FETCH_ENTRETIENS_BY_CANDIDATURE_REQUEST = "FETCH_ENTRETIENS_BY_CANDIDATURE_REQUEST";
export const FETCH_ENTRETIENS_BY_CANDIDATURE_SUCCESS = "FETCH_ENTRETIENS_BY_CANDIDATURE_SUCCESS";
export const FETCH_ENTRETIENS_BY_CANDIDATURE_FAIL = "FETCH_ENTRETIENS_BY_CANDIDATURE_FAIL";

export const CREATE_ENTRETIEN_REQUEST = "CREATE_ENTRETIEN_REQUEST";
export const CREATE_ENTRETIEN_SUCCESS = "CREATE_ENTRETIEN_SUCCESS";
export const CREATE_ENTRETIEN_FAIL = "CREATE_ENTRETIEN_FAIL";

export const setEntretiensLoading = (v) => ({
    type: SET_ENTRETIENS_LOADING,
    payload: v,
});

export const setEntretiensError = (msg) => ({
    type: SET_ENTRETIENS_ERROR,
    payload: msg,
});

export const fetchEntretiensByCandidatureRequest = (candidatureId) => ({
    type: FETCH_ENTRETIENS_BY_CANDIDATURE_REQUEST,
    payload: { candidatureId },
});

export const fetchEntretiensByCandidatureSuccess = (candidatureId, data) => ({
    type: FETCH_ENTRETIENS_BY_CANDIDATURE_SUCCESS,
    payload: { candidatureId, data },
});

export const fetchEntretiensByCandidatureFail = (err) => ({
    type: FETCH_ENTRETIENS_BY_CANDIDATURE_FAIL,
    payload: err,
});

export const createEntretienRequest = (payload) => ({
    type: CREATE_ENTRETIEN_REQUEST,
    payload,
});

export const createEntretienSuccess = (data) => ({
    type: CREATE_ENTRETIEN_SUCCESS,
    payload: data,
});

export const createEntretienFail = (err) => ({
    type: CREATE_ENTRETIEN_FAIL,
    payload: err,
});